import { Commodity } from '../types';

export const commodities: Commodity[] = [
  {
    id: 'gold',
    name: 'Gold Bullion & Dore Bars',
    tagline: 'AU dore and refined bars, 22–24 carat',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a2d64625-e454-4812-9979-27675f185726.jpg',
    grade: '22–24 carat / 96.5–99.99% purity',
    origin: 'Haut-Katanga & Nord Kivu, DRC',
    form: 'Dore bars and refined 1kg bars',
    packaging: 'Sealed security boxes, dual-custody',
    minOrder: '10 kg',
    unit: 'per kg',
    incoterms: 'CIF / FOB / DDP',
    monthlyCapacity: '150 – 400 kg',
    description:
      'Sourced from licensed cooperatives and semi-industrial concessions, every bar is fire-assayed on site and re-verified by an independent laboratory before release. Buyers receive assay certificates, origin declarations and export permits with the lot.',
    specs: [
      { label: 'Purity', value: '96.5% – 99.99% Au' },
      { label: 'Bar size', value: '1 kg standard, dore on request' },
      { label: 'Assay', value: 'Fire assay + XRF, SGS verified' },
      { label: 'Documents', value: 'Assay, CoO, export permit, airway bill' },
      { label: 'Payment', value: 'Irrevocable LC or escrow on delivery' },
    ],
  },
  {
    id: 'silver',
    name: 'Silver Bullion',
    tagline: '999 fine bars and granules',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/f9704790-c6be-4b54-bc8b-d4a116de2e87.jpg',
    grade: '99.9% Ag minimum',
    origin: 'Haut-Katanga, sourced through partner refiners',
    form: 'Cast bars, granules',
    packaging: 'Strapped pallets, 500 kg per unit',
    minOrder: '500 kg',
    unit: 'per kg',
    incoterms: 'CIF / FOB',
    monthlyCapacity: '8 – 20 t',
    description:
      'Refined silver recovered from polymetallic concentrate streams, cast into bars or granulated for industrial buyers. Priced against LBMA silver benchmark with transparent refining and freight breakdowns.',
    specs: [
      { label: 'Purity', value: '99.9% – 99.99% Ag' },
      { label: 'Bar size', value: '15 kg cast bars / granules' },
      { label: 'Assay', value: 'ICP-OES certificate per melt' },
      { label: 'Pricing', value: 'LBMA benchmark ± negotiated premium' },
      { label: 'Payment', value: 'LC at sight, 30% advance accepted' },
    ],
  },
  {
    id: 'copper-cathodes',
    name: 'Copper Cathodes',
    tagline: 'LME Grade A, 99.99% Cu',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/199fbb39-efb6-4262-8cba-1ea271c4c2dd.jpg',
    grade: 'LME Grade A — 99.99% Cu',
    origin: 'Partner SX-EW plants, Haut-Katanga',
    form: 'Full plate cathode sheets',
    packaging: 'Banded bundles, 2 – 2.5 t each',
    minOrder: '100 t',
    unit: 'per tonne',
    incoterms: 'FOB Dar es Salaam / CIF Asia & EU',
    monthlyCapacity: '1,000 – 3,000 t',
    description:
      'Our core industrial line. Cathodes are drawn from long-term offtake agreements with Katangan SX-EW plants, inspected at bundling and re-weighed at the bonded warehouse before container sealing.',
    specs: [
      { label: 'Purity', value: '99.99% Cu, LME Grade A' },
      { label: 'Sheet size', value: '1000 x 1000 mm, 3 – 5 mm' },
      { label: 'Inspection', value: 'Alfred H. Knight weight & quality' },
      { label: 'Route', value: 'Kasumbalesa → Dar es Salaam / Durban' },
      { label: 'Payment', value: 'LC 100% at sight against documents' },
    ],
  },
  {
    id: 'copper-concentrates',
    name: 'Copper Concentrates',
    tagline: '20–32% Cu content, bulk export',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c7a745dc-b2a6-419e-83be-37f250d3d5ab.jpg',
    grade: '20% – 32% Cu',
    origin: 'Kolwezi, Likasi, Lubumbashi belt',
    form: 'Filtered concentrate, 8–10% moisture',
    packaging: '1.5 t bulka bags or loose bulk',
    minOrder: '500 t',
    unit: 'per dry metric tonne',
    incoterms: 'FOB / CIF',
    monthlyCapacity: '3,000 – 8,000 t',
    description:
      'Blended to buyer specification with declared penalty elements. Each lot ships with a full sampling protocol, moisture determination and umpire assay clause written into the contract.',
    specs: [
      { label: 'Cu content', value: '20% – 32%, blended to spec' },
      { label: 'Moisture', value: '8% – 10% as shipped' },
      { label: 'Penalties', value: 'As, Pb, Zn declared per lot' },
      { label: 'Sampling', value: 'Three-party sampling, umpire clause' },
      { label: 'Payment', value: '90% provisional, 10% on final assay' },
    ],
  },
  {
    id: 'rough-diamonds',
    name: 'Rough Diamonds',
    tagline: 'Kimberley Process certified parcels',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2b8934db-4194-48be-b7a8-73b7e970f266.jpg',
    grade: 'Gem and near-gem, 0.5 – 8 ct stones',
    origin: 'Kasai & Nord Kivu alluvial fields',
    form: 'Sorted parcels by size and clarity',
    packaging: 'Sealed KP parcels with manifest',
    minOrder: '100 ct',
    unit: 'per carat',
    incoterms: 'CIF Antwerp / Dubai / Mumbai',
    monthlyCapacity: '2,000 – 6,000 ct',
    description:
      'Every parcel is exported with a Kimberley Process Certificate and a stone-by-stone manifest. Viewing can be arranged at our Butembo office or through a bonded diamond centre in the destination market.',
    specs: [
      { label: 'Sizes', value: '0.5 ct – 8 ct, larger on request' },
      { label: 'Colour', value: 'D – K, browns available separately' },
      { label: 'Certification', value: 'Kimberley Process, per parcel' },
      { label: 'Viewing', value: 'Butembo, Antwerp or Dubai bonded room' },
      { label: 'Payment', value: 'Escrow against sight inspection' },
    ],
  },
  {
    id: 'gemstones',
    name: 'Coloured Gemstones',
    tagline: 'Emerald, tourmaline, sapphire, tanzanite',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8668a572-ddc9-44bd-8a52-7853fe6e358e.jpg',
    grade: 'Rough and preform, commercial to fine',
    origin: 'Nord Kivu, Kivu belt & regional partners',
    form: 'Rough lots, graded preforms',
    packaging: 'Sealed lots with weight manifest',
    minOrder: '1 kg rough / 50 ct fine',
    unit: 'per kg or per carat',
    incoterms: 'CIF Bangkok / Jaipur / Dubai',
    monthlyCapacity: '40 – 120 kg rough',
    description:
      'Graded lots of emerald, green and bi-colour tourmaline, sapphire, tanzanite, amethyst and garnet. Fine single stones are offered individually with photographs, weights and independent gemmological opinion.',
    specs: [
      { label: 'Species', value: 'Emerald, tourmaline, sapphire, tanzanite' },
      { label: 'Quality', value: 'Commercial, good and fine grades' },
      { label: 'Reporting', value: 'GIA / GRS opinion on fine stones' },
      { label: 'Lots', value: 'Mixed rough or single-species sorted' },
      { label: 'Payment', value: 'Escrow or 50/50 on inspection' },
    ],
  },
];

export const commodityById = (id: string) => commodities.find((c) => c.id === id);
